module.exports = __webpack_public_path__ + "static/media/logo.00f15a7d.png";